import React from 'react';
import CRUDDetailPage from '../../../../shared/components/crud/CRUDDetailPage';
import { vaccineDispatchConfig } from '../config/vaccineDispatchConfig';
import { VaccineDispatchService } from '../../../../shared/services/vaccineDispatchService';

/**
 * VaccineDispatchDetail - URL-based detail page for Vaccine Dispatch
 * Handles view, edit, and add modes with ID from URL params
 */
export default function VaccineDispatchDetail() {
  return (
    <CRUDDetailPage
      config={vaccineDispatchConfig}
      service={VaccineDispatchService}
    />
  );
}
